// !! This file is auto-generated, refer to the icon component story for more info' !!
import { SVGTemplateResult } from 'lit';
import {
  house,
  iconChevCircleDown,
  iconChevCircleSolid,
  iconChevCircleUp,
  iconChevCircle,
  iconChevron,
  iconClock,
  iconExternalLink,
  iconMapAlt,
  iconMapPinSolid,
  iconMapPin,
  iconMapUserPin,
  iconOchsnerList,
  iconPhone,
  iconProviderSingle,
  iconProvidersMultiple,
  iconWalking,
  myOchsnerLogo,
  ochsnerHealthLogo,
} from './generated-svgs/customIcons';
import {
  iconFacebook,
  iconInstagram,
  iconLinkedin,
  iconPinterest,
  iconTwitter,
  iconYoutube,
} from './generated-svgs/socialIcons';
import {
  iconNewCall,
  iconNewCampusMap,
  iconNewChat,
  iconNewClipboard,
  iconNewComputer,
  iconNewEstimate,
  iconNewFaq,
  iconNewLocations,
  iconNewPayBill2,
  iconNewSearch,
  iconNewUrgentCare2,
  iconNewVirtualVisit2,
} from './generated-svgs/solidIcons';

export type IconList = {
  [key: string]: SVGTemplateResult;
};

export const custom: IconList = {
  house,
  'icon-chev-circle-down': iconChevCircleDown,
  'icon-chev-circle-solid': iconChevCircleSolid,
  'icon-chev-circle-up': iconChevCircleUp,
  'icon-chev-circle': iconChevCircle,
  'icon-chevron': iconChevron,
  'icon-clock': iconClock,
  'icon-external-link': iconExternalLink,
  'icon-map-alt': iconMapAlt,
  'icon-map-pin-solid': iconMapPinSolid,
  'icon-map-pin': iconMapPin,
  'icon-map-user-pin': iconMapUserPin,
  'icon-ochsner-list': iconOchsnerList,
  'icon-phone': iconPhone,
  'icon-provider-single': iconProviderSingle,
  'icon-providers-multiple': iconProvidersMultiple,
  'icon-walking': iconWalking,
  'my-ochsner-logo': myOchsnerLogo,
  'ochsner-health-logo': ochsnerHealthLogo,
};

export const social: IconList = {
  'icon-facebook': iconFacebook,
  'icon-instagram': iconInstagram,
  'icon-linkedin': iconLinkedin,
  'icon-pinterest': iconPinterest,
  'icon-twitter': iconTwitter,
  'icon-youtube': iconYoutube,
};

export const solid: IconList = {
  'icon-new-call': iconNewCall,
  'icon-new-campus-map': iconNewCampusMap,
  'icon-new-chat': iconNewChat,
  'icon-new-clipboard': iconNewClipboard,
  'icon-new-computer': iconNewComputer,
  'icon-new-estimate': iconNewEstimate,
  'icon-new-faq': iconNewFaq,
  'icon-new-locations': iconNewLocations,
  'icon-new-pay-bill-2': iconNewPayBill2,
  'icon-new-search': iconNewSearch,
  'icon-new-urgent-care-2': iconNewUrgentCare2,
  'icon-new-virtual-visit-2': iconNewVirtualVisit2,
};

export const iconList: IconList = {
  ...custom,
  ...social,
  ...solid,
};
